import { Store } from 'vuex';
import { Route } from 'vue-router';
import has from 'lodash/has';
import filter from 'lodash/filter';

/* eslint-disable-next-line */
export default function fiLockDown(store: Store<any>) {

	//todo shape next
	// eslint-disable-next-line @typescript-eslint/ban-types
	const checkOwned = (to: Route, next: Function) => {
		if (store.state.auth.headerData && store.state.auth.headerData.isFiOwned) {
			const clientId = store.state.auth.headerData.ownerFi.id;
			if (to.path == '/'
				|| has(to.params, 'clientId') && to.params.clientId !== clientId) {
				next({ path: `/${clientId}` });
			} else {
				next();
			}
		} else {
			next();
		}
	};
	
	//todo shape next
	// eslint-disable-next-line @typescript-eslint/ban-types
	return async (to: Route, from: Route, next: Function) => {
		// check or wait for user to be loaded
		if (store.state.auth.userStatus !== 'loaded') {
			try {
				await store.dispatch('auth/initializePortalSession', store);
			} catch (err) {
				// you are 401 or 403
				next();
				return;
			}
		}

		// map /:clientId to FI
		if (has(to.params, 'clientId') && store.state.auth.headerData) {
			if (store.state.auth.headerData.isFiOwned) {
				to.meta.fi = store.state.auth.headerData.ownerFi;
			} else {
				const fi = filter(store.state.auth.headerData.fis, { 'id': to.params.clientId })[0];
				to.meta.fi = fi;
			}
		}

		// handle external user lock down
		checkOwned(to, next);
	};
}